import { Action } from 'components/molecules/Action'
import type { SectionProps } from './types'

import './index.scss'

const mainClass = 'section'

export const Section = ({
  id,
  className = '',
  title,
  subtitle,
  note,
  action,
  caption,
  children,
}: SectionProps) => {
  return (
    <section id={id} className={mainClass}>
      {(title || subtitle) && (
        <header className={`${mainClass}__head`}>
          {title && <h2 className={`${mainClass}__title`}>{title}</h2>}
          {subtitle && <p className={`${mainClass}__subtitle`}>{subtitle}</p>}
          {caption && <p className={`${mainClass}__caption`}>{caption}</p>}
        </header>
      )}

      <div className={`${mainClass}__content ${className}`}>{children}</div>

      <footer className={`${mainClass}__footer`}>
        {note && <p className={`${mainClass}__note`}>{note}</p>}
        {action && (
          <div className={`${mainClass}__action-wrap`}>
            <Action action={action} className={`${mainClass}__action`} />
          </div>
        )}
      </footer>
    </section>
  )
}
